import { Plaque } from "./Plaque";
import type { KothRoundState } from "./useKothRound";
import { useChainNow } from "../../util/useChainNow";

/**
 * Wall-mounted countdown. Reads `round.expiresAt` and ticks against on-chain
 * unix time (via useChainNow) — surfpool's Clock drifts ~109min ahead of host
 * wall-clock, so using Date.now() here would show the wrong time-left.
 */

interface RoundTimerPlaqueProps {
  round: KothRoundState | null;
  position: [number, number, number];
  rotation?: [number, number, number];
}

export function RoundTimerPlaque({
  round,
  position,
  rotation,
}: RoundTimerPlaqueProps): JSX.Element {
  const chainNow = useChainNow(500);

  const settled = round?.status === 1;
  const expiresAtSec = round ? Number(round.expiresAt.toString()) : 0;
  const secsLeft = round && !settled ? Math.max(0, expiresAtSec - chainNow) : 0;

  let label: string;
  let color: string;
  if (!round) {
    label = "—:—";
    color = "#9aa0b4";
  } else if (settled) {
    label = "SETTLED";
    color = "#9aa0b4";
  } else {
    const mm = Math.floor(secsLeft / 60).toString().padStart(2, "0");
    const ss = (secsLeft % 60).toString().padStart(2, "0");
    label = `${mm}:${ss}`;
    color = secsLeft > 60 ? "#7af09e" : secsLeft > 10 ? "#f4d36a" : "#f47a7a";
  }

  return (
    <Plaque
      position={position}
      rotation={rotation}
      width={2.4}
      height={1.6}
      backerColor="#1f1f2a"
      title="TIME LEFT"
      titleColor="#9aa0b4"
      titleSize={0.22}
      lines={[label]}
      bodyColor={color}
      bodySize={0.48}
    />
  );
}
